var magazineSlider = new Swiper('.magazine-slider', {

  slidesPerView: 1,
  spaceBetween: 32,
  observer: true,
  observeParents: true,
  navigation: {
    nextEl: '.button-next',
    prevEl: '.button-prev',
  },
  breakpoints: {
    1024: {
      slidesPerView: 3,
      spaceBetween: 64,
    },
    640: {
      slidesPerView: 2,
      spaceBetween: 32,
    }
  }

});

var magazineSlider = new Swiper('.block-slider', {
  slidesPerView: 1,
  spaceBetween: 32,
  loop: true,
  speed: 500,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
  breakpoints: {
    1024: {
      slidesPerView: 2,
      spaceBetween: 32,
    },
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
});



// WEBPACK FOOTER //
// ./assets/js/sliders.js